import React from 'react'
import styles from '../../styles.module.css'


const fmt = (v) => (v === null || v === undefined || v === '') ? '—' : v

const formatDate = (d) => {
  if (!d) return ''
  const s = String(d).slice(0, 10)
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    const [y, m, day] = s.split('-')
    return `${day}.${m}.${y}`
  }
  return s
}

const formatNumberAndDate = (number, date) => {
  const n = (number === null || number === undefined || number === '') ? '' : String(number)
  const d = formatDate(date)
  if (!n && !d) return '—'
  return (
    <>
      {n && <div>{n}</div>}
      {d && <div>от {d}</div>}
    </>
  )
}

const TOTAL_COLS = 7


const DischargedTable = ({ rows, organizationName }) => {

  const sorted = [...(rows || [])].sort((a, b) => {
    const fa = (a.fio || '').toLowerCase()
    const fb = (b.fio || '').toLowerCase()
    return fa.localeCompare(fb, 'ru')
  })

  return (
    <table className={styles.mainTable}>
      <thead>
        <tr className={styles.titleRow}>
          <th className={styles.titleLeft} colSpan={TOTAL_COLS - 1}>Сведения об отчисленных</th>
          <th className={styles.titleRight}>Форма №4/СВУ</th>
        </tr>
        <tr className={`${styles.titleRow} ${styles.secondTitleRow}`}>
          <th className={styles.titleLeft} colSpan={TOTAL_COLS - 1}>{organizationName}</th>
          <th className={styles.titleRight}>Таблица №2</th>
        </tr>
        <tr>
          <th>№ п/п</th>
          <th>ФИО обучающегося</th>
          <th>Класс</th>
          <th>Причины отчисления</th>
          <th>Дата и номер приказа НУ</th>
          <th>Дата и номер протокола педагогического совета</th>
          <th>Примечание</th>
        </tr>
      </thead>
      <tbody>
        {sorted.length === 0 && (
          <tr>
            <td colSpan={TOTAL_COLS}>Нет отчисленных за период</td>
          </tr>
        )}
        {sorted.map((s, i) => (
          <tr key={s.studentId ?? i}>
            <td>{i + 1}</td>
            <td>{fmt(s.fio)}</td>
            <td>{fmt(s.className)}</td>
            <td>{fmt(s.dischargeReason)}</td>
            <td>{formatNumberAndDate(s.orderNumber, s.orderDate)}</td>
            <td>{formatNumberAndDate(s.protocolNumber, s.protocolDate)}</td>
            <td>{fmt(s.note)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default DischargedTable
